import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { AuthShell, Field, inputCls, SubmitBtn } from "@/components/student/AuthShell";
import { apiError } from "@/lib/student-auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StudentForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/student/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err?.response?.data?.detail, "Could not send the reset link"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      testid="student-forgot-page"
      eyebrow="Password reset"
      title="Forgot your password?"
      subtitle="We'll email you a secure link, valid for 24 hours."
      footer={
        <Link to="/student/login" data-testid="link-back-login" className="text-[#06B6D4] font-medium">
          Back to login
        </Link>
      }
    >
      {sent ? (
        <div data-testid="forgot-sent" className="text-sm text-slate-300 leading-relaxed">
          <div className="text-[#06B6D4] font-semibold mb-2">Check your inbox</div>
          If an account exists for <strong className="text-white">{email}</strong>, a reset link is on its
          way. The link expires in 24 hours — never share it with anyone.
        </div>
      ) : (
        <form onSubmit={submit} data-testid="student-forgot-form">
          <Field label="Email ID">
            <input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={inputCls}
              placeholder="you@example.com"
            />
          </Field>
          {error && (
            <div data-testid="forgot-error" className="mb-4 rounded-xl border border-rose-500/30 bg-rose-500/10 px-4 py-3 text-xs text-rose-200">
              {error}
            </div>
          )}
          <SubmitBtn loading={loading} testid="forgot-submit">
            Send reset link
          </SubmitBtn>
        </form>
      )}
    </AuthShell>
  );
}
